module.exports = __webpack_public_path__ + "img/screen_3.5f50d37b.svg";